<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 financeTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="settings"
                        arrows >
                    <template slot="gofixTab:settings">
                        <general-settings></general-settings>
                        <gofix-card title="Reason for cancellation" class="position-relative" fullContent>
                            <reasons></reasons>
                        </gofix-card>
                        <gofix-card title="Part Replacement Reason Code For Rejection" class="position-relative" fullContent>
                            <reasons-part-replacement></reasons-part-replacement>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import tabData from '@/data/_tabs';
    const generalSettings = () => import("./general")
    const reasons = () => import("./reasons")
    const reasonsPartReplacement = () => import("./reasons-part-replacement")
    export default {
        name: 'fm-codes',
        components: {
            generalSettings,
            reasons,
            reasonsPartReplacement
        },
        data () {
            return {
                contract_tab:tabData.client_contract,
            }
        },
        watch: {

        },
        created() {

        },
        methods:{

        }
    }
</script>